import type { JSONContent } from '@tiptap/core';

/** A stored article/description body — ProseMirror JSON (the schema is the sanitizer). */
export type ArticleDoc = JSONContent;

/** A resolved asset row (Spec 39) — the metadata an image node references by id. */
export interface AssetRecord {
  id: string;
  publicUrl: string;
  altText: string;
  caption: string | null;
  credit: string | null;
  width: number | null;
  height: number | null;
}

/** assetId → resolved asset. renderDocument(doc, assets) resolves image nodes through it. */
export type AssetMap = Record<string, AssetRecord>;

/** Canonical empty document: the composer's initial value. */
export const EMPTY_DOC: ArticleDoc = { type: 'doc', content: [{ type: 'paragraph' }] };
